import { Component, JSXElement, For, Show } from 'solid-js';
import CustomTooltip from '../CustomTooltip/CustomTooltip';
import Spinner from '../Spinner/Spinner';

export interface TagItem {
  label: string;
  value?: string;
  isValid?: boolean;
}

export interface TagItemsProps {
  tags: TagItem[];
  activeIndex: number;
  search: string;
  onAddTag(tag: TagItem): void;
  isLoading: boolean;
  notFoundErrorMsg?: string;
  matchCase?: boolean;
  tagListTitle?: string;
  'data-cy'?: string;
}

function highlightMatch(
  source: string,
  key: string,
  matchCase = true
): JSXElement {
  const adjustedSource = matchCase ? source : source.toLowerCase();
  const adjustedKey = matchCase ? key : key.toLowerCase();
  const matchIdx = adjustedSource.indexOf(adjustedKey);
  const matchedKey = source.slice(matchIdx, matchIdx + key.length);
  const parts = source.split(matchedKey);
  const result: JSXElement[] = [];

  parts.forEach((part, i) => {
    result.push(<>{part}</>);
    if (i < parts.length - 1) {
      result.push(<strong>{matchedKey}</strong>);
    }
  });

  return <>{result}</>;
}

const TagItems: Component<TagItemsProps> = (props): JSXElement => {
  const matchCase = (): boolean => props.matchCase ?? true;

  return (
    <div
      class="auto-complete te-top-fix"
      data-testid={props['data-cy'] || 'tag-items'}
    >
      <ul class="mw-100">
        <Show
          when={!props.isLoading}
          fallback={
            <li>
              <div class="select-menu-item">
                <Spinner show={true} />
              </div>
            </li>
          }
        >
          <Show
            when={props.tags.length > 0}
            fallback={
              <li>
                <div class="select-menu-item">{props.notFoundErrorMsg}</div>
              </li>
            }
          >
            <Show when={props.tagListTitle}>
              <li>
                <div class="select-menu-item">
                  <h6 class="text-meta">{props.tagListTitle}</h6>
                </div>
              </li>
            </Show>
            <For each={props.tags}>
              {(tag, index) => (
                <li>
                  <div
                    class={`select-menu-item ${props.activeIndex === index() ? 'bg-gray_0' : ''}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      props.onAddTag(tag);
                    }}
                  >
                    <CustomTooltip text={tag.label}>
                      <div class="text-ellipsis small">
                        {/* eslint-disable-next-line custom/no-direct-solid-component-invocation -- Tracked by https://jira.trimble.tools/browse/TWENG-38 */}
                        {highlightMatch(tag.label, props.search, matchCase())}
                      </div>
                    </CustomTooltip>
                  </div>
                </li>
              )}
            </For>
          </Show>
        </Show>
      </ul>
    </div>
  );
};

export default TagItems;
